jQuery(document).ready(function ($) {

    var CW_theme_framework = (function () {

        var originalJs = function () {

            // Location .squares-grid fix removing <br> tags
            $('.squares-grid').find('> br').remove();

            $('input, textarea').on('focus', function () {
                if ($(this).attr('placeholder')) $(this).data('placeholder', $(this).attr('placeholder')).removeAttr('placeholder');
            }).on('blur', function () {
                if ($(this).data('placeholder')) $(this).attr('placeholder', $(this).data('placeholder')).removeData('placeholder');
            });

            //Skip Link test2
            var skipLink = function () {
                $(".skiplink").focusin(function () {
                    $(this).css("position", "static");
                });

                $(".skiplink").focusout(function () {
                    $(this).css("position", "absolute");
                });
            }

            //No comments
            $("#commentform").addClass("noauto");

            //Hover for Desktop, click for mobile nav
            /*if ($(window).width() > 767) {
                $('.dropdown').on('mouseenter mouseleave click tap', function() {
                    $(this).toggleClass("open");
                });
            }*/

            //Footer Location Selection
            $('.location-drop').change(function() {
                var $chosenLoc = $(this).val();
                $('.location-info').removeClass('active');
                $('.location-info.' + $chosenLoc).addClass('active');
            });

            //Back to top
            $(window).scroll(function(){
                var scrollPosition = $(this).scrollTop();
                if(scrollPosition >= 650) {
                    $('.btn-back').fadeIn();
                } else {
                    $('.btn-back').fadeOut();
                }
            });

            // Mobile sticky nav
            if ($(window).width() < 768) {

                // set top position of nav bar at time of page load
                var initialPos = $('.sticky-nav').offset().top;
                console.log(initialPos);

                $(window).scroll(function(){

                    console.log(initialPos);

                    // keep track of top position as user scrolls
                    var currentPos = $(this).scrollTop();

                    console.log(currentPos);

                    if(currentPos > initialPos) {
                        $(".sticky-nav").css({'position': 'fixed', 'top': 0});
                    } else {
                        $(".sticky-nav").css({'position': 'relative', 'top': 'auto'});
                    }

                });

            }

            // PA intro - dynamic sidebar negative margin
            if($('.practice.intro').length > 0 && $(window).width() >= 992) {

                // create a fn that gets the height of the intro div, and uses that to calculate the sidebar top margin offset on the fly
                function practiceSidebar() {

                    //full intro div outer height (includes padding)
                    var introHeight = $('.practice.intro').outerHeight();

                    //set intro height value to negative, and take the top padding of .intro and .main-content into account
                    var marginOffset = ~introHeight + 14;

                    // set the css property
                    $('.practice.main-content .sidebar.sidebar-offset').css({'margin-top': marginOffset});

                }

                // call the fn on load
                practiceSidebar();

                // call the fn when page resizes for responsive
                $( window ).resize(function() {
                    practiceSidebar();
                });

            }

        };

        var tableOfContents = function () {

            var ToC = '';

            var newLine, el, title, link;

            $(".toc-heading").each(function () {

                el = $(this);
                title = el.text();
                link = "#" + el.attr("id");

                newLine =
                    "<li>" +
                    "<a class='toc-link' href='" + link + "'>" +
                    title +
                    "</a>" +
                    "</li>";

                ToC += newLine;

            });

            //console.log(ToC);

            //ToC += "</ul></div></div></div>";

            $(".toc-table ul").prepend(ToC);

            //$('.toc-table ul').smoothScroll();

            $(".toc-link:empty").each(function () {
                $(this).parent().css({
                    display: 'none'
                });
            });

        };

        var sameHeight = function () {

            $(window).load(function () {

                $('.grid-attorney .attorney-item').matchHeight();
                $('.grid-videos .video-description').matchHeight();
                $('.grid-results .item').matchHeight();
                $('.contact-sidebar .col-item').matchHeight();

            });

        };

        var scrollToSection = function () {

            var scroll = new SmoothScroll('a[href*="#"]', {
                // Selectors
                ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
                header: null, // Selector for fixed headers (must be a valid CSS selector)
                topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"
                speed: 500, // Integer. Amount of time in milliseconds it should take to scroll 1000px
                speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
                durationMax: null, // Integer. The maximum amount of time the scroll animation should take
                durationMin: null, // Integer. The minimum amount of time the scroll animation should take
                clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
                offset: 0,
                updateURL: false,
                popstate: false,
                // Easing
                easing: 'easeInOutCubic', // Easing pattern to use
                customEasing: function (time) {
                    // Function. Custom easing pattern
                    // If this is set to anything other than null, will override the easing option above

                    // return <your formulate with time as a multiplier>

                    // Example: easeInOut Quad
                    return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
                }
            });

        };

        var requiredInput = function () {

            $('.input-required').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-required').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

        };

        var hoverMenu = function () {

            function fnIsAppleMobile() {
                if (navigator && navigator.userAgent && navigator.userAgent != null) {
                    var strUserAgent = navigator.userAgent.toLowerCase();
                    var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
                    if (arrMatches != null)
                        return true;
                } // End if (navigator && navigator.userAgent)

                return false;
            } // End Function fnIsAppleMobile

            var bIsAppleMobile = fnIsAppleMobile();

            if ($(window).width() >= 768) {

                if (!bIsAppleMobile) {

                    $('#nav-desktop').find('.dropdown').hover(function () {
                        $(this).addClass('show');
                        $(this).find('.dropdown-menu').first().addClass('show').addClass('animated fadeIn').one('animationend oAnimationEnd mozAnimationEnd webkitAnimationEnd', function () {
                            $(this).removeClass('animated fadeIn');
                        });
                    }, function () {
                        $(this).removeClass('show');
                        $(this).find('.dropdown-menu').first().removeClass('show');
                    });

                    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {

                        if (!$(this).next().hasClass('show')) {
                            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                        }

                        var $subMenu = $(this).next(".dropdown-menu");

                        $subMenu.toggleClass('show');

                        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
                            $('.dropdown-submenu .show').removeClass("show");
                        });

                        return false;

                    });

                }

            } else {

                $('#nav-mobile .nav-link.dropdown-toggle').on('click', function () {
                    $(this).next().slideToggle();
                });

            }


        };

        var videoFixes = function () {
            if ($(".cw_video_single").length > 0) {
                $(".cw_video_single").attr("src", $(".cw_video_single").attr("src").replace("rel=", "rel=0"));
            }
        };

        var carousels = function () {

            var awards = $(".awards-wrap");

            awards.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-awards'
            });

            $(window).load(function () {

                $('.awards-wrap .award-slide').matchHeight();

            });

            var team = $(".team-slider");

            team.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-team'
            });

            var testimonials = $('.testimonials-section-slider');

            testimonials.slick({
                dots: false,
                infinite: false,
                appendArrows: '.custom-nav-test',
            });

            var sidebar_results = $('.results-slider__sidebar .grid-results');

            sidebar_results.slick({
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-results',
            });

            if ($(window).width() <= 767) {

                var results = $(".results-holder");

                results.slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    appendArrows: '.custom-nav-results',
                });

                var videos = $(".grid-videos");
                videos.slick({
                    dots: true,
                    arrows: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                });

            }

        };

        return {

            init: function () {
                originalJs();
                tableOfContents();
                sameHeight();
                scrollToSection();
                requiredInput();
                hoverMenu();
                videoFixes();
                carousels();
            }

        }

    })();

    CW_theme_framework.init();

});
